export const CONSTS = {
  LABEL: $localize`Report Format`,
  OPTION_1: $localize`PDF`,
  OPTION_2: $localize`CSV`,
};

export enum Options {
  PDF = 'PDF',
  CSV = 'CSV',
}
